module.exports = __webpack_public_path__ + "img/kkb_m290_2w.5ab5d3ae.png";